import * as Sentry from "@sentry/react";
import packageJson from "../../../package.json";
var setupSentry = function () {
    var initialiseSentry = function (_a) {
        var username = _a.username, email = _a.email;
        var version = process.env.NODE_ENV === "development" ? "dev" : packageJson.version;
        Sentry.init({
            dsn: "https://7ce54f2b9d2a4d2bbc9261ed3da5d9df@o55978.ingest.sentry.io/6118778",
            // For Sentry release tracking
            release: "observability-microscope-plugin@" + version,
            // Provides us with the current user in Sentry
            initialScope: {
                user: username && email ? { username: username, email: email } : undefined,
            },
        });
    };
    // Get the current user for Sentry tracking
    fetch("https://manager-service.us-west-2.prod.atl-paas.net/api/v1/auth/validate", { credentials: "include" })
        .then(function (res) { return res.json(); })
        .then(function (_a) {
        var username = _a.username, email = _a.email;
        initialiseSentry({ username: username, email: email });
    })
        .catch(function (error) {
        Sentry.captureException(error);
        initialiseSentry({});
    });
};
export default setupSentry;
